import { graphql } from 'graphql-schema';

const GET_VENUE_PRICING = graphql(`
  query venue($venueId: uuid!) {
    venue: venues_by_pk(_id: $venueId) {
      _id
      timeslots_summary {
        _id
        lowest_vp_rental_price
        lowest_non_vp_rental_price
        highest_vp_rental_price
        highest_non_vp_rental_price
      }
    }
  }
`);

export default GET_VENUE_PRICING;
